// react-router-dom components
import { useNavigate, useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Market Place React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
import { FileUploader } from "react-drag-drop-files";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// Authentication layout components
import Joi from "joi";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { setDirection, useMaterialUIController } from "context";
import { storeNewOrder, getOrder, updateOrder } from "controllers/OrderController";
import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { getUsersList } from "controllers/UserController";
import AdapterJalali from "@date-io/date-fns-jalali";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import config from "config";
import Footer from "examples/Footer";
import { ImageViewer } from "react-image-viewer-dv";
import { getCollaboratorsList } from "controllers/UserController";
import { updateOrderCancel } from "controllers/OrderController";
import { uploadImages } from "controllers/OrderController";
import { RemoveOrderImage } from "controllers/OrderController";

const productTypes = [
  "پلاک",
  "پلاک زنجیر",
  "گوشواره",
  "انگشتر",
  "دستبند",
  "دستبند زنجیر",
  "دستبند چرم",
  "سرویس",
  "نیمست زنجیر",
];
const buildTypes = ["لیزری", "ریخته گری", "دست ساز", "حک"];
const platings = ["بدون آبکاری", "طلایی", "رزگلد", "رادیوم"];
const orderStates = ["در انتظار طراحی", "در انتظار ساخت", "در انتظار ارسال", "ارسال شده"];
const endUserContactTyps = ["اینستاگرام", "سایت", "حضوری"];
const endUserSendTypes = ["تیپاکس", "پست پیشتاز", "پست ویژه", "کوشا", "باربری", "پیک", "حضوری"];

const emptyData = {
  material: "طلا",
  type: "پلاک",
  buildType: "لیزری",
  collaborator: undefined,
  deliveryDate: "",
  weight: "",
  pelakWeight: "",
  zanjirWeight: "",
  height: "",
  width: "",
  thickness: "",
  plating: "بدون آبکاری",
  orderState: "در انتظار طراحی",
  createdAt: "",
  belongings: "",
  description: "",
  explanation: "",
  endUser: 1,
  endUserName: "",
  endUserAddress: "",
  endUserContactTyp: "اینستاگرام",
  endUserSendType: "تیپاکس",
  endUserPostalCode: "",
  endUserDescription: "",
  collaboratorWeight: "",
  endWeight: "",
  wages: "",
  endWages: "",
  endDate: "",
  collaboratorDate: "",
  endUserPrice1: "",
  endUserPrice2: "",
  goldDayPrice: "",
  materialPrice: "",
  postPrice: "",
  platingPrice: "",
  factorNumber: "",
  sellPrice: "",
  profit: "",
  images: [],
  // picture,
};
const allowedRoles = [
  "supperadmin",
  "admin",
  "saleadmin",
  "saller",
  "designer",
  "production",
  "productionadmin",
];

function newOrder(props) {
  const [fields, setFields] = useState(emptyData);
  const [collaborators, setCollaborators] = useState();
  const [, setReload] = useState(new Date());
  const [selectedImage, setSelectedImage] = useState();

  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const { id, mode, show } = useParams();
  const navigate = useNavigate();

  const numberFormat = (number) => {
    try {
      //var nf = new Intl.NumberFormat();
      //return nf.format(number); // "1,234,567,890"
      if (number) {
        let res = Number((number + "").replace(/,/g, "")).toLocaleString();
        if (res + "" === "NaN") {
          return "";
        }
        return res;
      }
      return "";
    } catch (err) {
      return "";
    }
  };
  const uploadProductImages = async (file) => {
    try {
      setLoading(true);
      const res = await uploadImages(id, file, controller.token);
      setLoading(false);
      if (res.success) {
        const temp = fields;
        temp.images.push(res.data);

        setFields(temp);
        setReload(new Date());
      }
    } catch (err) {
      //console.log("err", err);
    }
  };
  const RemoveOrderImageHandler = async (image) => {
    try {
      setLoading(true);
      const res = await RemoveOrderImage(
        {
          id,
          image,
        },
        controller.token
      );
      setLoading(false);
      if (res.success) {
        const temp = fields;
        temp.images = temp.images.filter((a) => a !== image);

        setFields(temp);
        setReload(new Date());
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleChangeImages = async (files) => {
    for (let i = 0; i < files.length; i++) {
      uploadProductImages(files[i]);
    }

    setReload(new Date());
  };
  const getDatas = async () => {
    setLoading(true);
    const filters = {
      userRole: "collaborator",
      supperCollaborator: mode === "1" ? true : false,
    };
    if (id === "new") {
      filters.delete = false;
    } else {
      filters.delete = true;
    }
    const res = await getCollaboratorsList(3000, 1, "", filters, controller.token);
    setLoading(false);
    if (res.success) {
      const tempc = fields;

      let supperCollaborator = [];
      if (mode == 1) {
        setCollaborators(res.data);
        supperCollaborator = res.data.filter((a) => a.supperCollaborator + "" == "true");
      } else {
        setCollaborators(res.data.filter((a) => a.supperCollaborator + "" !== "true"));
      }

      if (supperCollaborator.length > 0) {
        let currentSupper = supperCollaborator.filter((a) => a._id + "" == controller.id + "");

        if (currentSupper.length > 0) {
          tempc.collaborator = currentSupper[0]._id;
        } else {
          tempc.collaborator = supperCollaborator[0]._id;
        }
      } else {
        if (res.data.filter((a) => a._id + "" === controller.id + "").length > 0)
          tempc.collaborator = controller.id;
      }
      setFields(tempc);
      setReload(new Date());
      if (id !== "new") {
        const orderData = await getOrder({ id }, controller.token);
        if (orderData.success) {
          const tempp = orderData.data;
          if (!tempp.images) tempp.images = [];
          setFields(tempp);
        } else {
          Swal.fire({
            text: `${res.message} (${res.code})`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        }
      }
    } else {
      Swal.fire({
        text: `${res.message} (${res.code})`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    if (res.code === 401) {
      navigate("/", { replace: true });
    }
  };
  const handleSubmitClick = async () => {
    let errorText = [];
    if (!fields.explanation) {
      errorText.push("شرح محصول را وارد نمایید");
    }
    if (!fields.material) {
      errorText.push("جنس محصول را وارد نمایید");
    }

    if (!fields.type) {
      errorText.push(" نوع محصول را وارد نمایید");
    }
    if (!fields.buildType) {
      errorText.push(" نوع ساخت را وارد نمایید");
    }
    if (!fields.weight) {
      errorText.push("  وزن کل درخواستی را وارد نمایید");
    }
    if (!fields.plating) {
      errorText.push("  آبکاری را وارد نمایید");
    }
     if (mode === "0" && !fields.collaborator) {
      errorText.push(" همکار سفارش دهنده را انتخاب نمایید");
    }
    if (mode === "1") {
      if (!fields.endUserName) {
        errorText.push("  نام مشتری را وارد نمایید");
      }
      if (!fields.endUserPhone) {
        errorText.push("  شماره تماس مشتری را وارد نمایید");
      }
      if (!fields.endUserPrice1) {
        errorText.push("  قیمت درخواستی مشتری را وارد نمایید");
      }
      if (!fields.endUserPrice2) {
        errorText.push("  بیعانه را وارد نمایید");
      }

      if (fields.orderState === "ارسال شده") {
        if (!fields.endDate) {
          errorText.push("تاریخ تحویل به مشتری را وارد نمایید");
        }
        if (!fields.sellPrice) {
          errorText.push("قیمت فروش را وارد نمایید");
        }
        if (!fields.profit) {
          errorText.push("سود را وارد نمایید");
        }
        if (!fields.endWeight) {
          errorText.push("وزن تحویلی به مشتری را وارد نمایید");
        }
      }
    }
    if (fields.orderState === "در انتظار ارسال") {
      if (!fields.collaboratorWeight && fields.buildType === "لیزری") {
        errorText.push("  وزن تحویلی به همکار را وارد نمایید");
      }
      if (!fields.collaboratorDate) {
        errorText.push("  تاریخ تحویل به همکار را وارد نمایید");
      }
      if (!fields.wages) {
        errorText.push("  اجرت بخش مالی همکار را وارد نمایید");
      }
    }

    if (errorText.length > 0) {
      let erText = "";
      errorText.map((item) => {
        erText += item;
        erText += "<br/>";
      });

      Swal.fire({
        html: erText,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    // if (!fields.deliveryDate) {
    //   Swal.fire({
    //     text: " تاریخ تحویل را وارد نمایید",
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }

    // if (!fields.height) {
    //   Swal.fire({
    //     text: "ابعاد درخواستی را وارد نمایید",
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }

    // if (!fields.weight) {
    //   Swal.fire({
    //     text: "ابعاد درخواستی را وارد نمایید",
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }

    // if (!selectedImage && (!fields.picture || (fields.picture && fields.picture.length < 8))) {
    //   Swal.fire({
    //     text: `لطفا یک تصویر برای سفارش انتخاب کنید`,
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }
    setLoading(true);
    const temp = fields;
    temp.endUser = mode;
    // temp.wages = Number(temp.wages + "".replace(/,/g, ""));
    // temp.endUserPrice1 = Number(temp.endUserPrice1 + "".replace(/,/g, ""));
    // temp.endUserPrice2 = Number(temp.endUserPrice2 + "".replace(/,/g, ""));
    // temp.goldDayPrice = Number(temp.goldDayPrice + "".replace(/,/g, ""));
    // temp.materialPrice = Number(temp.materialPrice + "".replace(/,/g, ""));
    // temp.postPrice = Number(temp.postPrice + "".replace(/,/g, ""));
    // temp.platingPrice = Number(temp.platingPrice + "".replace(/,/g, ""));
    // temp.sellPrice = Number(temp.sellPrice + "".replace(/,/g, ""));
    temp.profit = Number(temp.profit + "".replace(/,/g, ""));
    let res;
    if (id !== "new") {
      res = await updateOrder(temp, selectedImage, controller.token);
    } else {
      res = await storeNewOrder(temp, selectedImage, controller.token);
    }
    setLoading(false);
    if (res.success) {
      Swal.fire({
        html: res.message,
        icon: "success",
        confirmButtonText: "متوجه شدم",
      });
      navigate(-1);
      //navigate("/activeorders", { replace: true });
      // clearForm();
    } else {
      Swal.fire({
        text: `${res.message} (${res.code})`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    if (res.code === 401) {
      navigate("/", { replace: true });
    }
  };
  const changeHandler = (event) => {
    // if (event.target.files[0].size > 307200) {
    //   Swal.fire({
    //     text: `حجم تصویر نمی تواند بیشتر از ۳۰۰ کلیوبایت باشد`,
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }
    setSelectedImage(event.target.files[0]);
  };
  const startPage = async () => {
    if (!controller.authenticated) {
      Swal.fire({
        text: "برای دسترسی به این صفحه باید وارد حساب کاربری خود شوید",
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });
      navigate("/", { replace: true });
    } else {
      if (allowedRoles.filter((a) => a == controller.userRole).length > 0) {
        setDirection(dispatch, "rtl");
        getDatas();
      } else {
        Swal.fire({
          text: "سطح دسترسی مناسب برای ورود به این صفحه را ندارید",
          icon: "error",
          confirmButtonText: "بسیار خوب",
        });
        navigate("/dashboard", { replace: true });
        return;
      }
    }
  };
  const handleCancelClick = async (id, canceled) => {
    setLoading(true);
    let res = await updateOrderCancel({ id, canceled: !canceled }, controller.token);
    setLoading(false);

    if (res.success) {
      navigate("/activeorders", { replace: true });
    } else {
      Swal.fire({
        text: `${res.message} (${res.code})`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    if (res.code === 401) {
      navigate("/", { replace: true });
    }
  };
  useEffect(() => {
    if (
      [
        "supperadmin",
        "saleadmin",
        "saller",
        "productionadmin",
        "designer",
        "production",
        "designer",
        "accountants",
      ].filter((a) => a == controller.userRole).length == 0
    ) {
      Swal.fire({
        text: "سطح دسترسی مناسب برای ورود به این صفحه را ندارید",
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });
      navigate("/dashboard", { replace: true });
      return;
    }
    startPage();
    return () => {
      setFields(emptyData);
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar title="ثبت سفارش" />
      <LoadingOverlay className="overlayclass" active={loading} spinner text=" لطفا کمی صبر کنید">
        <MDBox py={3}>
          {[
            "supperadmin",
            "saller",
            "saleadmin",
            "productionadmin",
            "production",
            "designer",
          ].filter((a) => a == controller.userRole).length > 0 && (
            <Card mb={2}>
              <MDBox
                variant="gradient"
                bgColor="secondary"
                borderRadius="lg"
                coloredShadow="success"
                mx={2}
                mt={-3}
                p={1}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h6" fontWeight="medium" color="white">
                  مشخصات سفارش
                </MDTypography>
              </MDBox>
              <MDBox pt={2} pb={3} px={3}>
                <MDBox component="form" role="form">
                  <Grid container spacing={2} mb={1}>
                    <Grid item lg={4} md={6} xs={8}>
                      <div className="custom-file">
                        <input
                          type="file"
                          accept="image/*"
                          className="custom-file-input"
                          id="image"
                          name="image"
                          onChange={changeHandler}
                        />
                        <div id="imageStatus" className="custom-file-label" htmlFor="selectedImage">
                          {selectedImage && selectedImage.name}
                          {!selectedImage && "انتخاب تصویر"}
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={6} xs={4}>
                      {id !== "new" && (
                        <div
                          style={{ maxWidth: 75, maxHeight: 75, width: "100%", overflow: "hidden" }}
                        >
                          <ImageViewer>
                            <img
                              src={`${config.fileserver}product/${fields.picture}`}
                              style={{ width: "100%", resize: "center" }}
                              alt="گالری محتشم"
                            />
                          </ImageViewer>
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        type="text"
                        label="شرح محصول"
                        variant="outlined"
                        fullWidth
                        error={!fields.explanation}
                        value={fields.explanation}
                        onChange={(event) => {
                          const temp = fields;
                          temp.explanation = event.target.value;
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mb={1}>
                    <Grid item lg={4} md={6} xs={12}>
                      {fields.orderState !== "ارسال شده" && (
                        <FileUploader
                          multiple
                          handleChange={handleChangeImages}
                          name="file"
                          types={["JPEG", "JPG", "PNG", "GIF"]}
                          label="Images"
                          maxSize={1}
                        />
                      )}
                    </Grid>
                    <Grid
                      container
                      lg={8}
                      md={12}
                      xs={12}
                      style={{
                        flex: 1,
                        flexDirection: "row",

                        marginTop: 15,
                        minHeight: 75,
                      }}
                    >
                      {fields.images &&
                        fields.images.map((item) => (
                          <>
                            <div
                              style={{
                                maxWidth: 55,
                                maxHeight: 55,

                                borderRadius: 5,
                                width: "100%",
                                overflow: "hidden",
                                margin: 5,
                                marginTop: 10,
                                borderWidth: 1,
                                borderColor: "#000",
                              }}
                            >
                              {(show + "" === "2" || show + "" === "0") && (
                                <HighlightOffIcon
                                  style={{
                                    position: "absolute",
                                    marginTop: -5,
                                    marginRight: -5,
                                  }}
                                  onClick={() => {
                                    Swal.fire({
                                      title: "",
                                      icon: "warning",
                                      text: "آیا مایل به ادامه  هستید",
                                      showCloseButton: false,
                                      showCancelButton: true,
                                      focusConfirm: false,
                                      confirmButtonText: "بله",
                                      cancelButtonText: "خیر",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        RemoveOrderImageHandler(item);
                                      }
                                    });
                                  }}
                                />
                              )}
                              <ImageViewer>
                                <img
                                  alt="گالری محتشم"
                                  src={`${config.fileserver}product/${item}`}
                                  style={{ width: "100%", resize: "center" }}
                                />
                              </ImageViewer>
                            </div>
                          </>
                        ))}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="userRole">جنس محصول</InputLabel>
                        <Select
                          dir="rtl"
                          id="material"
                          labelId="label-material"
                          label="جنس محصول"
                          value={fields.material}
                          onChange={(event) => {
                            const temp = fields;
                            temp.material = event.target.value;
                            setFields(temp);
                            setReload(new Date());
                          }}
                        >
                          <MenuItem value="طلا">طلا</MenuItem>
                          <MenuItem value="نقره">نقره</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="type">نوع محصول</InputLabel>
                        <Select
                          dir="rtl"
                          id="type"
                          labelId="label-type"
                          label="نوع محصول"
                          value={fields.type}
                          onChange={(event) => {
                            const temp = fields;
                            temp.type = event.target.value;
                            setFields(temp);
                            setReload(new Date());
                          }}
                        >
                          {productTypes.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="buildType">نوع ساخت</InputLabel>
                        <Select
                          dir="rtl"
                          id="buildType"
                          labelId="label-buildType"
                          label="نوع ساخت"
                          value={fields.buildType}
                          onChange={(event) => {
                            const temp = fields;
                            temp.buildType = event.target.value;
                            setFields(temp);
                            setReload(new Date());
                          }}
                        >
                          {buildTypes.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      {collaborators && (
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={collaborators}
                          value={
                            collaborators.filter((a) => a.id + "" === fields.collaborator + "")
                              .length > 0
                              ? collaborators.filter(
                                  (a) => a.id + "" === fields.collaborator + ""
                                )[0].label
                              : null
                          }
                          onChange={(event, newValue) => {
                            const temp = fields;
                            temp.collaborator = newValue.id;
                            setFields(temp);
                            setReload(new Date());
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="همکار سفارش دهنده" />
                          )}
                        />
                      )}
                      {/* <Autocomplete                         
                        id="combo-box-demo"
                        options={collaborators}
                         renderInput={(params) => <TextField {...params} label="Movie" />}
                      /> */}
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterJalali}>
                        <DatePicker
                          label="تاریخ تحویل"
                          mask="____/__/__"
                          value={fields.deliveryDate}
                          onChange={(newValue) => {
                            const temp = fields;
                            temp.deliveryDate = newValue;
                            setFields(temp);
                            setReload(new Date());
                          }}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        type="number"
                        label="وزن کل درخواستی"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="InputAdornment" position="start">
                              gr
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        fullWidth
                        error={!fields.weight}
                        value={`${fields.weight}`}
                        onChange={(event) => {
                          const temp = fields;
                          temp.weight = event.target.value.replace(/[۰-۹]/g, (d) =>
                            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                          );
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        type="number"
                        label="وزن پلاک درخواستی"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="InputAdornment" position="start">
                              gr
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        fullWidth
                        value={`${fields.pelakWeight}`}
                        onChange={(event) => {
                          const temp = fields;
                          temp.pelakWeight = event.target.value.replace(/[۰-۹]/g, (d) =>
                            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                          );
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    {(fields.type === "پلاک زنجیر" ||
                      fields.type === "دستبند زنجیر" ||
                      fields.type === "نیمست زنجیر") && (
                      <Grid item lg={4} md={6} xs={12}>
                        <TextField
                          type="number"
                          label="وزن زنجیر درخواستی"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment className="InputAdornment" position="start">
                                gr
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                          fullWidth
                          value={`${fields.zanjirWeight}`}
                          onChange={(event) => {
                            const temp = fields;
                            temp.zanjirWeight = event.target.value.replace(/[۰-۹]/g, (d) =>
                              "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                            );
                            setFields(temp);
                            setReload(new Date());
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item lg={2} md={3} xs={6}>
                      <TextField
                        type="number"
                        label="طول"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="InputAdornment" position="start">
                              mm
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        fullWidth
                        value={fields.height}
                        onChange={(event) => {
                          const temp = fields;
                          temp.height = event.target.value.replace(/[۰-۹]/g, (d) =>
                            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                          );
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    <Grid item lg={2} md={3} xs={6}>
                      <TextField
                        type="number"
                        label="عرض"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="InputAdornment" position="start">
                              mm
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        fullWidth
                        value={`${fields.width}`}
                        onChange={(event) => {
                          const temp = fields;
                          temp.width = event.target.value.replace(/[۰-۹]/g, (d) =>
                            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                          );
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        type="number"
                        label="ضخامت"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="InputAdornment" position="start">
                              db
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                        value={`${fields.thickness}`}
                        onChange={(event) => {
                          // if (event.target.value < 10) {
                          //   Swal.fire({
                          //     text: `ضخامت باید بیشتر از ۱۰ باشد`,
                          //     icon: "error",
                          //     confirmButtonText: "متوجه شدم",
                          //   });
                          //   return;
                          // }
                          if (event.target.value > 120) {
                            Swal.fire({
                              text: `ضخامت باید کمتر از ۱۲۰ باشد`,
                              icon: "error",
                              confirmButtonText: "متوجه شدم",
                            });
                            return;
                          }
                          const temp = fields;
                          temp.thickness = event.target.value.replace(/[۰-۹]/g, (d) =>
                            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                          );
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="plating">آبکاری</InputLabel>
                        <Select
                          dir="rtl"
                          id="plating"
                          labelId="label-plating"
                          label="آبکاری"
                          value={fields.plating}
                          onChange={(event) => {
                            const temp = fields;
                            temp.plating = event.target.value;
                            setFields(temp);
                            setReload(new Date());
                          }}
                        >
                          {platings.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="orderState">وضعیت</InputLabel>
                        <Select
                          dir="rtl"
                          id="orderState"
                          labelId="label-orderState"
                          label="وضعیت"
                          value={fields.orderState}
                          onChange={(event) => {
                            const temp = fields;
                            temp.orderState = event.target.value;
                            setFields(temp);
                            setReload(new Date());
                          }}
                        >
                          {orderStates.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {id !== "new" && (
                      <Grid item lg={4} md={6} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterJalali}>
                          <DatePicker
                            disabled
                            label="تاریخ ثبت"
                            mask="____/__/__"
                            value={fields.createdAt}
                            onChange={(newValue) => {
                              const temp = fields;
                              temp.createdAt = newValue;
                              setFields(temp);
                              setReload(new Date());
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    )}
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        type="text"
                        label="متعلقات"
                        variant="outlined"
                        fullWidth
                        value={`${fields.belongings}`}
                        onChange={(event) => {
                          const temp = fields;
                          temp.belongings = event.target.value;
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    <Grid item lg={8} md={6} xs={12}>
                      <TextField
                        type="text"
                        label="توضیحات"
                        variant="outlined"
                        fullWidth
                        value={`${fields.description}`}
                        onChange={(event) => {
                          const temp = fields;
                          temp.description = event.target.value;
                          setFields(temp);
                          setReload(new Date());
                        }}
                      />
                    </Grid>
                    {/* <Grid item lg={4} md={6} xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="endUser">مشتری نهایی</InputLabel>
                    <Select
                      dir="rtl"
                      id="endUser"
                      labelId="label-endUser"
                      label="مشتری نهایی"
                      value={mode}
                      onChange={(event) => {
                        const temp = fields;
                        temp.endUser = event.target.value;
                        setFields(temp);
                        setReload(new Date());
                      }}
                    >
                      <MenuItem value={1}>دارد</MenuItem>
                      <MenuItem value={0}>ندارد</MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          )}
          {mode === "1" &&
            ["supperadmin", "saller", "saleadmin"].filter((a) => a == controller.userRole).length >
              0 && (
              <div style={{ marginTop: 35 }}>
                <Card>
                  <MDBox
                    variant="gradient"
                    bgColor="secondary"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={1}
                    mb={1}
                    textAlign="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      مشخصات مشتری
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox component="form" role="form">
                      <Grid container mt={1} spacing={2}>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="text"
                            label="اسم"
                            variant="outlined"
                            fullWidth
                            error={!fields.endUserName}
                            value={`${fields.endUserName}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserName = event.target.value;
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="text"
                            label="آدرس"
                            variant="outlined"
                            fullWidth
                            value={fields.endUserAddress}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserAddress = event.target.value;
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="number"
                            label="شماره تماس"
                            variant="outlined"
                            fullWidth
                            error={!fields.endUserPhone}
                            value={`${fields.endUserPhone}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserPhone = event.target.value.replace(/[۰-۹]/g, (d) =>
                                "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                              );
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="endUserContactTyp">نحوه ارتباط</InputLabel>
                            <Select
                              dir="rtl"
                              id="endUserContactTyp"
                              labelId="label-endUserContactTyp"
                              label="نحوه ارتباط"
                              value={fields.endUserContactTyp}
                              onChange={(event) => {
                                const temp = fields;
                                temp.endUserContactTyp = event.target.value;
                                setFields(temp);
                                setReload(new Date());
                              }}
                            >
                              {endUserContactTyps &&
                                endUserContactTyps.map((item) => (
                                  <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="endUserSendType">نحوه ارسال</InputLabel>
                            <Select
                              dir="rtl"
                              id="endUserSendType"
                              labelId="label-endUserSendType"
                              label="نحوه ارسال"
                              value={fields.endUserSendType}
                              onChange={(event) => {
                                const temp = fields;
                                temp.endUserSendType = event.target.value;
                                setFields(temp);
                                setReload(new Date());
                              }}
                            >
                              {endUserSendTypes &&
                                endUserSendTypes.map((item) => (
                                  <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="number"
                            label="کدپستی"
                            variant="outlined"
                            fullWidth
                            value={`${fields.endUserPostalCode}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserPostalCode = event.target.value.replace(/[۰-۹]/g, (d) =>
                                "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                              );
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            label="توضیحات"
                            variant="outlined"
                            fullWidth
                            value={`${fields.endUserDescription}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserDescription = event.target.value;
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </Card>
              </div>
            )}
          {(fields.buildType === "لیزری" || fields.buildType === "حک") &&
            ["supperadmin", "saleadmin", "productionadmin", "accountants"].filter(
              (a) => a == controller.userRole
            ).length > 0 && (
              <div style={{ marginTop: 35 }}>
                <Card>
                  <MDBox
                    variant="gradient"
                    bgColor="secondary"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={1}
                    mb={1}
                    textAlign="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      مالی همکار
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox component="form" role="form">
                      <Grid container mt={1} spacing={2}>
                        {fields.buildType === "لیزری" && (
                          <Grid item lg={4} md={6} xs={12}>
                            <TextField
                              type="number"
                              label="وزن تحویلی همکار"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment className="InputAdornment" position="start">
                                    gr
                                  </InputAdornment>
                                ),
                              }}
                              variant="outlined"
                              fullWidth
                              value={`${fields.collaboratorWeight}`}
                              onChange={(event) => {
                                const temp = fields;
                                temp.collaboratorWeight = event.target.value.replace(
                                  /[۰-۹]/g,
                                  (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                                );
                                setFields(temp);
                                setReload(new Date());
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item lg={4} md={6} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                              label="تاریخ تحویل به همکار"
                              mask="____/__/__"
                              value={fields.collaboratorDate}
                              onChange={(newValue) => {
                                const temp = fields;
                                temp.collaboratorDate = newValue;
                                setFields(temp);
                                setReload(new Date());
                              }}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="اجرت"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.wages + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.wages = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              // temp.wages = temp.wages
                              //   .toString()
                              //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </Card>
              </div>
            )}
          {mode === "1" &&
            ["supperadmin", "saller", "saleadmin", "accountants"].filter(
              (a) => a == controller.userRole
            ).length > 0 && (
              <div style={{ marginTop: 35 }}>
                <Card>
                  <MDBox
                    variant="gradient"
                    bgColor="secondary"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={1}
                    mb={1}
                    textAlign="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      مالی مشتری
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox component="form" role="form">
                      <Grid container mt={1} spacing={2}>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="قیمت درخواستی مشتری"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            error={!fields.endUserPrice1}
                            value={numberFormat(fields.endUserPrice1 + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserPrice1 = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="بیعانه"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            error={!fields.endUserPrice2}
                            value={numberFormat(fields.endUserPrice2 + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endUserPrice2 = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                              label="تاریخ تحویل تحویل به مشتری"
                              mask="____/__/__"
                              value={fields.endDate}
                              
                              onChange={(newValue) => {
                                const temp = fields;
                                temp.endDate = newValue;
                                setFields(temp);
                                setReload(new Date());
                              }}
                              renderInput={(params) => (
                                <TextField 
                                error={fields.orderState === "ارسال شده" && !fields.endDate}

                                 {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        {fields.material === "طلا" && (
                          <Grid item lg={4} md={6} xs={12}>
                            <TextField
                              label="قیمت روز طلا"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment className="InputAdornment" position="start">
                                    تومان
                                  </InputAdornment>
                                ),
                              }}
                              variant="outlined"
                              fullWidth
                              value={numberFormat(fields.goldDayPrice + "")}
                              onChange={(event) => {
                                const temp = fields;
                                temp.goldDayPrice = event.target.value
                                  .replace(/,/g, "")
                                  .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                                setFields(temp);
                                setReload(new Date());
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="قیمت متریال"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.materialPrice + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.materialPrice = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="اجرت"
                            thousandSeparator
                            isNumericString
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.endWages + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endWages = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="هزینه ارسال"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.postPrice + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.postPrice = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="هزینه آبکاری"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.platingPrice + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.platingPrice = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="number"
                            label="شماره فاکتور"
                            variant="outlined"
                            fullWidth
                            value={`${fields.factorNumber}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.factorNumber = event.target.value;
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="قیمت فروش"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            value={numberFormat(fields.sellPrice + "")}
                            error={fields.orderState === "ارسال شده" && !fields.sellPrice}
                            onChange={(event) => {
                              const temp = fields;
                              temp.sellPrice = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            label="سود"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  تومان
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            error={fields.orderState === "ارسال شده" && !fields.profit}
                            value={numberFormat(fields.profit + "")}
                            onChange={(event) => {
                              const temp = fields;
                              temp.profit = event.target.value
                                .replace(/,/g, "")
                                .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>

                        <Grid item lg={4} md={6} xs={12}>
                          <TextField
                            type="number"
                            label="وزن تحویلی به مشتری"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment className="InputAdornment" position="start">
                                  gr
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            fullWidth
                            error={fields.orderState === "ارسال شده" && !fields.endWeight}
                            value={`${fields.endWeight}`}
                            onChange={(event) => {
                              const temp = fields;
                              temp.endWeight = event.target.value.replace(/[۰-۹]/g, (d) =>
                                "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
                              );
                              setFields(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </Card>
              </div>
            )}
          <MDBox mt={4} mb={1} spacing={2}>
            {(show + "" === "2" || show + "" === "0") && (
              <>
                <MDButton
                  variant="gradient"
                  color="info"
                  style={{ minWidth: "40%", float: "left" }}
                  onClick={() => {
                    handleSubmitClick();
                  }}
                >
                  ثبت
                </MDButton>
                {id !== "new" && (
                  <MDButton
                    variant="gradient"
                    color="error"
                    style={{ float: "left", marginLeft: 10, marginRigh: 10 }}
                    onClick={() => {
                      navigate(-1);
                      // Swal.fire({
                      //   title: "",
                      //   icon: "warning",
                      //   text: "آیا مایل به ادامه  هستید",
                      //   showCloseButton: false,
                      //   showCancelButton: true,
                      //   focusConfirm: false,
                      //   confirmButtonText: "بله",
                      //   cancelButtonText: "خیر",
                      // }).then(async (result) => {
                      //   if (result.isConfirmed) {
                      //     handleCancelClick();
                      //   }
                      // });
                    }}
                  >
                    انصراف
                  </MDButton>
                )}
                {id !== "new" &&
                  (controller.userRole === "supperadmin" ||controller.userRole ===  "productionadmin" ||controller.userRole ===  "saleadmin" ||controller.userRole ===  "saller") &&
                  fields.orderState !== "ارسال شده" && (
                    <MDButton
                      variant="gradient"
                      color="error"
                      style={{ float: "left", marginLeft: 10, marginRigh: 10 }}
                      onClick={() => {
                        Swal.fire({
                          title: "",
                          icon: "warning",
                          text: "آیا مایل به ادامه  هستید",
                          showCloseButton: false,
                          showCancelButton: true,
                          focusConfirm: false,
                          confirmButtonText: "بله",
                          cancelButtonText: "خیر",
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            handleCancelClick(id, fields.canceled);
                          }
                        });
                      }}
                    >
                      {fields.canceled ? "خارج کردن سفارش از وضعیت کنسلی" : " کنسل کردن سفارش"}
                    </MDButton>
                  )}
              </>
            )}
          </MDBox>
        </MDBox>
      </LoadingOverlay>

      <Footer />
    </DashboardLayout>
  );
}

export default newOrder;
